import FingerprintIcon from './FingerprintIcon'

export default FingerprintIcon
